import { render, staticRenderFns } from "./chillCarAlarmDetail.vue?vue&type=template&id=2c2cd1fb&scoped=true"
import script from "./chillCarAlarmDetail.vue?vue&type=script&lang=js"
export * from "./chillCarAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./chillCarAlarmDetail.vue?vue&type=style&index=0&id=2c2cd1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cd1fb",
  null
  
)

export default component.exports